// @flow
export const styles: Function = (theme: Object): Object => ({
    userComment: {
        width: '100%',
        padding: 20,
        boxShadow: '0 10px 10px 0 rgba(155, 155, 155, 0.07)',
    },
    avatarContainer: {
        flexBasis: 55,
    },
    avatar: {
        width: 40,
    },
    textContainer: {
        maxWidth: '92%',
        flexBasis: '92%',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '82%',
            flexBasis: '82%',
        },
    },
    avatar: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        height: 45,
        width: 45,
    },
    rankContainer: {
        textAlign: 'right',
        maxWidth: '40%',
        flexBasis: '40%',
    },
    nicknameContainer: {
        minWidth: 78,
        maxWidth: '60%',
        flexBasis: '60%',
    },
    nickname: {
        fontWeight: 500,
        fontSize: '0.875rem',
    },
    siteContainer: {
        marginBottom: 5,
    },
    commentContainer: {
        marginBottom: 5,
    },
    rank: {
        width: 52,
        height: 19,
        borderRadius: 8.5,
        textAlign: 'center',
        display: 'inline-block',
        fontSize: 13,
        fontWeight: 'normal',
        lineHeight: '19px',
        letterSpacing: 0,
    },
    rankRookie: {
        backgroundColor: '#ededed',
        color: '#9d9d9d',
    },
    rankBronze: {
        backgroundColor: '№f2f2f2',
        color: 'black',
    },
    rankSilver: {
        backgroundColor: '#bfbfbf',
        color: 'white',
    },
    rankGold: {
        backgroundColor: '#d0bd85',
        color: 'yellow',
    },
    rankPlatinum: {
        backgroundColor: '#cdd6de',
        color: 'white',
    },
    inline: {
        display: 'inline-block',
    },
    wordBreaker: {
        wordBreak: 'break-word',
    },
    reviewFontSize: {
        fontSize: '0.875rem',
    },
});

export default styles;
